import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { Button } from '@/features/public/home/components/Button'
import { Helmet } from 'react-helmet-async'
import { Tree } from '../components/Tree'

export const Testimonials = () => {
  return (
    <>
      <Helmet title="Testimonials" />
      <section className={`${pageXPadding} ${pageYPadding} `}>
        <div className={`${pageMaxWidth} flex flex-col gap-y-[24px] `}>
          <SectionTitle title="Testimonials" />
          <p className="font-nunito text-[16px] font-normal leading-[19.2px] text-[#000000]">
            {`Don't just take our word for it—see for yourself what our clients have to say! Explore their experiences and discover how we've turned visions into reality.`}
          </p>
          <Button>Send Review</Button>
        </div>
      </section>
      <section className="bg-homeLandingBg">
        <div className={`${pageXPadding} ${pageYPadding}`}>
          <div className={`${pageMaxWidth}  mx-auto`}>
            <Tree />
          </div>
        </div>
      </section>
    </>
  )
}
